<script setup lang="ts">
  import { computed, type Component } from 'vue';
  import { Monitor } from 'lucide-vue-next';
  import { IconImage } from '@/shared/ui';
  import EditableIcon from '@/shared/assets/icons/RecordTypeEditableIcon.svg';
  import UploadIcon from '@/shared/assets/icons/RecordTypeUploadIcon.svg';
  import ToolsIcon from '@/shared/assets/icons/RecordTypeToolsIcon.svg';

  const props = defineProps<{
    recordTypeName: string | null;
  }>();

  // Matched by name because record type ids are per branch.
  const BADGE_BY_RECORD_TYPE: Partial<
    Record<string, { icon: string | Component; colorClass: string }>
  > = {
    Editável: {
      icon: EditableIcon,
      colorClass: 'border-badge-info bg-badge-info-02 text-badge-info',
    },
    Upload: {
      icon: UploadIcon,
      colorClass: 'border-badge-orange bg-badge-orange-02 text-badge-orange',
    },
    'Editável (IF/API)': {
      icon: ToolsIcon,
      colorClass: 'border-badge-purple bg-badge-purple-02 text-badge-purple',
    },
    'Software externo': {
      icon: Monitor,
      colorClass: 'border-badge-cyan bg-badge-cyan-02 text-badge-cyan',
    },
  };

  const badge = computed(() => BADGE_BY_RECORD_TYPE[props.recordTypeName ?? '']);
</script>

<template>
  <span
    v-if="badge"
    role="img"
    :aria-label="recordTypeName ?? undefined"
    :class="[
      'inline-flex size-6 shrink-0 items-center justify-center rounded-md border',
      badge.colorClass,
    ]"
    data-testid="record-type-badge"
  >
    <IconImage
      :src="badge.icon"
      alt=""
      aria-hidden="true"
      class="size-4"
    />
  </span>
</template>
